import { MBUserTypingRemovalScheduler } from '@shared/scenes/chat/thread/util/typingScheduler';
import { API } from '@shared/types/api';

// exported for testing purposes
export const scheduler = new MBUserTypingRemovalScheduler();

export function scheduleRemoveUserTyping(user: API.ShortUserFragment, channelSlug: string) {
  scheduler.schedule(user, channelSlug);
}
